import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const ApprovalAffiliation = (props) => {
  const { values, onChange, hasEditPermission } = props;

  return (
    <Row className="Payment-details member-and-dependent">
      <Col className="pl-0">
        <h3>Is Approval Required for Affiliation?</h3>
        <p className="mb-2">
          If checked, the request will be sent to the Admin for approval, when
          Member sends a request for Affiliation.
        </p>
      </Col>
      <Col className="setup-form w-50">
        <div className="d-flex align-items-center ">
          <Form.Group className="w-50">
            <Form.Label>Registration</Form.Label>
            <Form.Check
              type="checkbox"
              checked={values.isRegistrationApproval}
              id="allowMember"
              onChange={(e) => {
                onChange(e);
              }}
              name="isRegistrationApproval"
              disabled={!hasEditPermission}
              isDisabled={!hasEditPermission}
              className={!hasEditPermission && 'disabled-checkbox'}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Self Affiliation</Form.Label>
            <Form.Check
              type="checkbox"
              checked={values.selfAffiliation}
              onChange={(e) => {
                onChange(e);
              }}
              id="allowDependent"
              name="selfAffiliation"
              disabled={!hasEditPermission}
              isDisabled={!hasEditPermission}
              className={!hasEditPermission && 'disabled-checkbox'}
            />
          </Form.Group>
        </div>
      </Col>
    </Row>
  );
};

export default ApprovalAffiliation;
